module.exports = __webpack_public_path__ + "static/media/bright-logo.fd13dc08.gif";